import { render, staticRenderFns } from "./icons.vue?vue&type=template&id=17876f6d&scoped=true&"
var script = {}
import style0 from "./icons.vue?vue&type=style&index=0&id=17876f6d&lang=scss&scoped=true&"
import style1 from "./icons.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "17876f6d",
  null
  
)

export default component.exports